<template>
  <div class="footer">
    <h1>[ 怎么装 - 您身边的家装顾问 ]</h1>
    <span>© 2022 www.zenmez.com</span>
    <span>怎么装装修网和设计师社区 保留所有权利</span>
    <a href="http://beian.miit.gov.cn/">沪ICP备20022660号</a>

  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style scoped lang="scss">
.footer {
  width: 100%;
  margin-top: 10px;
  background: #333;
  padding: 30px 0 40px;
  h1 {
    text-align: center;
    font-size: 12px;
    font-weight: 500;
    color: #999;
    margin: 0;
    line-height: 32px;
  }
  span {
    text-align: center;
    display: block;
    font-size: 10px;
    line-height: 20px;
    color: #999;
  }
  a{
       text-align: center;
    display: block;
    font-size: 10px;
    line-height: 20px;
    color: #999;
  }
}
</style>
